import { render, staticRenderFns } from "./DeleteAppointmentModal.vue?vue&type=template&id=cfc5f40e&scoped=true&class=fill-height&"
import script from "./DeleteAppointmentModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteAppointmentModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteAppointmentModal.vue?vue&type=style&index=0&id=cfc5f40e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc5f40e",
  null
  
)

export default component.exports